import { CaretDownOutlined, CheckOutlined, SearchOutlined } from '@vindr/icons';
import { Button, Row, Select } from 'antd';
import { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { ALLTIME_STUDYDATE, FILTER_TYPE, INITIAL_FILTER_STUDYLIST } from './constants';
import {
  ALLTIME_STUDYDATE,
  FILTER_TYPE,
  INITIAL_FILTER_STUDYLIST,
} from '@vindr/services/constants/study.constant';
import useSearchOptions, { StudylistFilters } from './useSearchOptions';
import { ParamsStudyList } from '@vindr/services/apis/study.api';
import { extendDateOptions } from '@vindr/ui/src/components/ui/DateRangePicker';

const { Option } = Select;

const INITIAL_SEARCH_FIELDS = [
  StudylistFilters.STUDYDATE,
  StudylistFilters.PATIENT_ID,
  StudylistFilters.PATIENT_NAME,
  StudylistFilters.MODALITY,
  // StudylistFilters.STATUS,
];

function Filter({ onChange, forceSearch }) {
  const { t } = useTranslation('Vindoc');
  const [params, setParams] = useState<ParamsStudyList>(INITIAL_FILTER_STUDYLIST);

  const onSearch = useCallback(
    (p, type) => {
      setParams(p);
      onChange(p, type);
    },
    [onChange]
  );

  const handleOnChangeFilter = useCallback(
    (p, type, values, triggerSearch = true) => {
      if (!type) return;
      let tempFilterData = {};
      if (type === FILTER_TYPE.STUDYDATE) {
        tempFilterData = {
          ...p,
          study_date_from: values[0].toISOString(),
          study_date_to: values[1].toISOString(),
        };
      } else {
        tempFilterData = {
          ...p,
          [type]: values,
        };
      }
      setIsFiltered(true);
      if (triggerSearch) {
        onSearch(tempFilterData, type);
      } else {
        onChangeParams(tempFilterData);
      }
    },
    [onSearch]
  );

  const SEARCH_OPTIONS = useSearchOptions(params, handleOnChangeFilter);

  const [searchFields, setSearchFields] = useState([...INITIAL_SEARCH_FIELDS]);
  const [isFiltered, setIsFiltered] = useState(false);

  const onChangeParams = (p) => {
    setParams(p);
  };

  // const handleOnSearch = () => {
  //   setIsFiltered(true);
  //   onSearch({ ...params });
  // };

  const handleChangeSearchKey = useCallback(
    (key, replacekey) => {
      let tempParams = { ...params };

      if (key === FILTER_TYPE.STUDYDATE) {
        tempParams = { ...tempParams, ...ALLTIME_STUDYDATE };
      } else {
        delete tempParams[key];
      }

      if (replacekey === FILTER_TYPE.STUDYDATE) {
        tempParams.study_date_from = extendDateOptions['Today'][0].toISOString();
        tempParams.study_date_to = extendDateOptions['Today'][1].toISOString();
      }

      setIsFiltered(true);
      onChangeParams(tempParams);

      let tempSearchField = [...searchFields];
      const currentItemIndex = SEARCH_OPTIONS.findIndex((it) => it.key == key);
      const replaceItemIndex = SEARCH_OPTIONS.findIndex((it) => it.key == replacekey);

      tempSearchField = tempSearchField.map((it) =>
        it == currentItemIndex ? replaceItemIndex : it
      );
      setSearchFields(tempSearchField);
    },
    [SEARCH_OPTIONS, params, searchFields]
  );

  const handleClearAllFilters = useCallback(() => {
    setSearchFields(INITIAL_SEARCH_FIELDS);
    setParams({ ...INITIAL_FILTER_STUDYLIST });
    onChange({ ...INITIAL_FILTER_STUDYLIST });
    setIsFiltered(false);
  }, [onChange]);

  return (
    <Row className="ml-[-7px] space-y-[7px] pt-3 pb-6" align="bottom">
      <div>
        <Row className="space-y-2" align="bottom">
          {searchFields &&
            SEARCH_OPTIONS &&
            searchFields.map((idx) => {
              const field = SEARCH_OPTIONS[idx];
              const options = SEARCH_OPTIONS.filter(
                (_, i) => i == idx || !searchFields.includes(i)
              );
              const Component = field?.component;

              return (
                <div key={field?.key} className="search-item">
                  <Row>
                    <div>
                      <Select
                        size="small"
                        className="select-dropdown-light border-0"
                        popupClassName="min-w-40"
                        menuItemSelectedIcon={<CheckOutlined />}
                        suffixIcon={<CaretDownOutlined />}
                        value={field.key}
                        onChange={(value) => handleChangeSearchKey(field.key, value)}
                      >
                        {options.map((item, idx) => (
                          <Option key={idx} value={item.key}>
                            {t(item.text)}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Row>
                  <Row className="pl-[7px]">
                    <div>{Component ? Component : null}</div>
                  </Row>
                </div>
              );
            })}
        </Row>
      </div>
      <div className="ml-[7px] flex flex-wrap space-x-2">
        <Button
          type="primary"
          className="flex items-center"
          size="small"
          icon={<SearchOutlined />}
          onClick={() => forceSearch?.(params)}
        >
          {t('Search')}
        </Button>
        <Button
          className="filter-btn"
          size="small"
          disabled={!isFiltered}
          onClick={handleClearAllFilters}
        >
          {t('Clear Filter')}
        </Button>
      </div>
    </Row>
  );
}

export default memo(Filter);
